import styled from "styled-components";

const GetQuoteButtonCss = styled.div`
  position: relative;
  margin-left: 0;
  button {
    position: relative;
    /* z-index: 99;
    bottom: 125px;
    right: 0; */
    border-radius: 0 0;
    /* background: linear-gradient(180deg, #61B01F 0%, #27911B 100%); */
    background-color: #ed1c24;
    color: #fff;
    border: none;
    padding: 3px 15px 3px 15px;
    font-size: 21px;
  }
  @media (min-width: 1441px) {
    width: fit-content;
    margin-left: calc(50vw - 726px);
    button {
      font-size: 21px;
    }
  }
  @media (max-width: 767px) {
    button {
      top: 116px;
      font-size: 21px;
    }
  }
 
`;
const ModalBodyWrapper = styled.div`
  .modal-body {
    padding: 0 !important;
  }
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 30px 25px 30px 25px;
  background: #00000005;
  align-items: end;
  .text-header {
    width: 95%;
    display: block;
  }
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
  p {
    font-size: 14px;
    margin: 0px;
  }
  img {
    height: 17px;
    width: 17px;
    margin-bottom: 2px;
    cursor: pointer;
  }
`;
const ContentWrapper = styled.div`
  padding: 0px 25px 10px 25px;
  .locationState {
    input {
      background: #00000005;
    }
  }
  .app-input-text {
    margin-bottom: 0px !important;
  }
  .radio-container {
    padding-top: 2px;
  }
  .mandatorystar {
    color: #a30202;
  }
  .deliveryDateClass {
    .file-input-wrapper .MuiFormControl-root {
      height: 37px;
    }
  }
  .textAreaClass {
    .app-input-text textarea {
      height: 58px;
    }
  }
  .timmerPickerStyle {
    position: relative;
    svg {
      position: absolute;
      top: 9px;
      right: 22px;
    }
  }
  .button-style {
    display: flex;
    justify-content: center;
    margin: 25px 10px 20px 10px;
    button {
      background: linear-gradient(180deg, #61b01f 0%, #27911b 100%);
      border: none;
      border-radius: 4px;
      color: #fff;
      padding: 5px 20px 5px 20px;
    }
  }
`;

export { GetQuoteButtonCss, ModalBodyWrapper, Header, ContentWrapper };
